// Zoom threshold below which node content is collapsed for performance
export const COLLAPSE_ZOOM_THRESHOLD = 0.25

// Helper to calculate zoom-independent scale factor
// - When zoomed in (zoom > 1): shrink elements, min 0.5 (allows more shrinking for readability)
// - When zoomed out (zoom < 1): grow elements proportionally, max 2.0
export const getZoomScale = (zoom: number) => {
  if (zoom >= 1) {
    // Zoomed in: shrink, but not below 50%
    return Math.max(0.5, 1 / zoom)
  }
  // Zoomed out: grow proportionally (1/zoom), capped at 2.0
  // At zoom 0.5: scale = 2, at zoom 0.7: scale = 1.43, at zoom 0.9: scale = 1.11
  return Math.min(2.0, 1 / zoom)
}
